import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { SubPortfolioMilestonesComponent } from './sub-portfolio-milestones.component';


const routes: Routes = [
  {
    path: '',
    component: SubPortfolioMilestonesComponent
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class SubPortfolioMilestonesRoutingModule { }
